exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__info___26Khb {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end; }\n\n.styles__infoText___3WjPk {\n  margin: 0;\n  font-family: \"Poppins\"; }\n  .styles__infoText___3WjPk > div > p {\n    white-space: initial;\n    text-align: justify;\n    margin: 0; }\n  .styles__infoText___3WjPk > div > ul {\n    margin: 0;\n    white-space: initial;\n    text-align: justify; }\n    .styles__infoText___3WjPk > div > ul > li {\n      padding: 5px 0;\n      white-space: initial;\n      text-align: justify; }\n\n.styles__infoIcon___3zutY {\n  margin-left: 8px; }\n\n@media (max-width: 768px) {\n  .styles__modalDescription___gGZox {\n    top: 45px; } }\n", ""]);

// exports
exports.locals = {
	"info": "styles__info___26Khb",
	"infoText": "styles__infoText___3WjPk",
	"infoIcon": "styles__infoIcon___3zutY",
	"modalDescription": "styles__modalDescription___gGZox"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/InputText/styles.scss
// module id = 2138
// module chunks = 6